import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell } from "@/pages/AuthPage";
import { api, formatApiError } from "@/lib/api";
import { useApp } from "@/lib/i18n";

export function ForgotPassword() {
  const { L } = useApp();
  const [email, setEmail] = useState("");
  const [res, setRes] = useState(null);
  const submit = async (e) => {
    e.preventDefault();
    try { setRes((await api.post("/auth/forgot-password", { email })).data); } catch (err) { toast.error(formatApiError(err)); }
  };
  return (
    <AuthShell>
      <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
        <h1 className="text-3xl font-extrabold tracking-tight">{L("Lupa kata laluan", "Forgot password")}</h1>
        <div className="space-y-2"><Label htmlFor="email">{L("Emel", "Email")}</Label><Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-11 rounded-xl" data-testid="forgot-email-input" /></div>
        <Button type="submit" className="h-11 w-full rounded-xl bg-violet-600 hover:bg-violet-700" data-testid="forgot-submit-btn">{L("Hantar pautan", "Send link")}</Button>
        {res && (
          <div className="rounded-xl bg-slate-50 p-3 text-sm" data-testid="forgot-result">
            <p>{L("Jika emel wujud, pautan set semula telah dihantar ke peti masuk anda. Semak folder spam jika tiada.", "If the email exists, a reset link has been sent to your inbox. Check spam if you can't find it.")}</p>
            {res.dev_reset_link && <a href={res.dev_reset_link} className="mt-2 block break-all text-xs font-semibold text-violet-700" data-testid="dev-reset-link">{L("[Mod pembangunan] Buka pautan set semula", "[Dev mode] Open reset link")}</a>}
          </div>
        )}
        <Link to="/login" className="block text-center text-sm font-semibold text-violet-700">{L("Kembali ke log masuk", "Back to log in")}</Link>
      </form>
    </AuthShell>
  );
}

export function ResetPassword() {
  const { L } = useApp();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/reset-password", { token: params.get("token"), password });
      toast.success(L("Kata laluan dikemas kini. Sila log masuk.", "Password updated. Please log in."));
      navigate("/login");
    } catch (err) { toast.error(formatApiError(err)); }
  };
  return (
    <AuthShell>
      <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
        <h1 className="text-3xl font-extrabold tracking-tight">{L("Tetapkan kata laluan baharu", "Set a new password")}</h1>
        <div className="space-y-2"><Label htmlFor="pw">{L("Kata laluan baharu", "New password")}</Label><Input id="pw" type="password" minLength={8} required value={password} onChange={(e) => setPassword(e.target.value)} className="h-11 rounded-xl" data-testid="reset-password-input" /></div>
        <Button type="submit" className="h-11 w-full rounded-xl bg-violet-600 hover:bg-violet-700" data-testid="reset-submit-btn">{L("Simpan", "Save")}</Button>
      </form>
    </AuthShell>
  );
}
